import { colors, fontSize } from '@styles/theme'
import styled from '@emotion/styled'

import { ToggleButton as MuiToggleButton } from '@mui/material'

const StyledToggleButton = styled(MuiToggleButton)`
  display: flex;
  align-items: center;
  justify-content: center;
  
  width: 100%;
  border-radius: 12px;
  border: 0.5px solid rgba(255,255,255, 0.15);
  
  background-color: #333333;
  color: white;
  font-size: ${fontSize('sm')}
  text-align: center;
  text-transform: none;
  line-height: unset;
  overflow: hidden;

  &.Mui-selected {
    background-color: ${colors.statusColors['right_now']('primary')};
    color: white;

    &:hover {
      background-color: ${colors.statusColors['right_now']('primary')};
    }
  }

  &:hover {
    background-color: #333333;
    color: white;
  }
`

const ToggleButton = ({ children, ...rest }) => {
  return (
    <StyledToggleButton {...rest}>
      {children}
    </StyledToggleButton>
  )
}

export { ToggleButton }
